
import { Grid, Typography } from '@mui/material';
import { IRoom } from '../../../interfaces/IPartnerPms';
import { useCallback, useMemo } from 'react';
import Dialog, { IDefaultDialogProps } from '../../Dialog';
import { ActionButton } from '../../Button';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import FormHelper from '../../../helpers/FormHelper';
import DefaultConstants from '../../../data/Constants';
import PartnerPmsService from '../../../services/PartnerPmsService';
import { RoomStatusData, RoomStatusEnum } from '../../../data/Enums';


const doNotDisturb = RoomStatusData[RoomStatusEnum.DoNotDisturb];


interface IDoNotDisturbConfirmationDialogProps extends IDefaultDialogProps {
    room: IRoom;
    handleRefreshSelectedRoom: () => void;
}

const DoNotDisturbConfirmationDialog: React.FC<IDoNotDisturbConfirmationDialogProps> = ({
    open,
    handleClose,
    room,
    handleRefreshSelectedRoom
}) => {
    const { translate } = useLanguageContext();
    

    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        let formData = FormHelper.Create(undefined);
        formData = FormHelper.Add(formData, 'roomId', room.id);
        formData = FormHelper.Add(formData, 'reservationId', room.checkInReservation?.id);
        formData = FormHelper.Add(formData, 'enableDoNotDisturb', (!room.doNotDisturb).toString());

        PartnerPmsService.UpdateRoomDoNotDisturb(formData).then(() => {
            handleRefreshSelectedRoom();
            handleClose();
        });

        // eslint-disable-next-line
    }, [room]);


    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='no' onClick={handleClose} />,
            <ActionButton action='yes' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);

    
    return (
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate(doNotDisturb.name)}
            dialogActions={dialogActions}
            onSubmit={handleSubmit}
            className='dialogactions-spacebetween overflow-inherit'
            absolute={true}
            dividers={true}
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                <Grid item xs={12}>
                    <Typography variant='body1'>
                        {translate(room.doNotDisturb ? '_governanceDialogDisableDoNotDisturbDescription' : '_governanceDialogEnableDoNotDisturbDescription')}
                    </Typography>
                </Grid>
            </Grid>
        </Dialog>
    );
}

export default DoNotDisturbConfirmationDialog;